import { FONT_NAME_ENUM } from './constants';

export const getDisplayName = (fontFamily) => {
  if (Object.keys(FONT_NAME_ENUM).includes(fontFamily)) {
    return FONT_NAME_ENUM[fontFamily];
  } else {
    return fontFamily;
  }
}
